import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { TableColumnModel } from '../../../shared/models/models';
import { ServiceSubscriptionEditorService } from '../service-subscription-editor/service-subscription-editor.service';
import { first } from 'rxjs/operators';
import { ConsoleLogger } from '../../../core/utilities/console-logger';
import { ServiceSubscriptionService } from '../../../fleet-manager/company/components/companydetails/options/company-services-options/service-subscription.service';
import { RateBuilderModel } from '../service-subscription-editor/models/rateBuilderModel';
import { ToastrService } from 'ngx-toastr';
import { ColumnMode } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-service-rates',
  templateUrl: './service-rates.component.html',
  styleUrls: ['./service-rates.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceRatesComponent implements OnInit {
  public subTableColumns:TableColumnModel[];
  public rates:any[];
  public serviceCodeList: any[];
  public chargeTypesList: any[];
  public companyServices: any[];
  public columnMode = ColumnMode;
  constructor(
    private serviceSubscriptionEditorService: ServiceSubscriptionEditorService,
    private toastrService: ToastrService,

  ) { }

  ngOnInit() {
    this.subTableColumns = [
      { name: 'Name',               prop: 'name',           width: 250 },
      { name: 'Charge Type',        prop: 'chargeTypeId',   width: 150 },
      { name: 'Service Code',       prop: 'serviceCodeId',  width: 150 },
      { name: 'Rate Type',          prop: 'rateType',       width: 150 },
      { name: 'Amount',             prop: 'amount',         width: 150 },
      { name: 'Charge Frequency',   prop: 'isRecurring',    width: 150 },
      { name: 'Charge Multiplier',  prop: 'multiplierName', width: 150 },
      { name: '# Multipliers',      prop: 'multiplier',     width: 100 },
      { name: 'EOM?',               prop: 'isEndOfMonth',   width: 50 },
    ];
    this.serviceSubscriptionEditorService.getCompanyServices(null)
      .toPromise()
      .then(cs=> {
        this.companyServices = cs;
    });
    this.serviceSubscriptionEditorService.getServiceCodeDropdown()
      .toPromise()
      .then((data: any) => {
        this.serviceCodeList = data;
    });
    this.serviceSubscriptionEditorService.getChargeTypes()
      .toPromise()
      .then(data =>{
      this.chargeTypesList = []
      data.forEach(d => {
        if(d.id < 4){
          this.chargeTypesList.push(d)
        }
      });
    })
    this.loadData();
  }

  public loadData(){
    this.serviceSubscriptionEditorService.getRateFullList()
    .pipe(first())
    .subscribe((resp: any) => {
      ConsoleLogger.logInfo('this.serviceSubscriptionEditorService.getRateFullList', resp)
      this.rates = resp;
    })
  }

  public displayServiceCode(serviceCodeId){
    const index = this.serviceCodeList.findIndex(fr => fr.serviceCodeId == serviceCodeId)
    if(index != -1){
      return this.serviceCodeList[index].description
      ;
    }
    return "";
  }

  public displayChargeType(chargeId){
    const index = this.chargeTypesList.findIndex(fr => fr.id == chargeId)
    if(index != -1){
      return this.chargeTypesList[index].chargeTypeName
      ;
    }
    return "";
  }

  public editModeRate(row){
    row.editChargeTypeId = row.chargeTypeId;
    row.editServiceCodeId = row.serviceCodeId;
    row.editRateType = row.rateType;
    row.editAmount = row.amount ? row.amount : 0;
    row.editMultiplier = row.multiplier ? row.multiplier : 0;
    row.editIsRecurring = row.isRecurring ? "Yes" : "No";
    row.editMultiplierName = row.multiplierName;
    row.editName = row.name;
    row.editIsEndOfMonth = row.isEndOfMonth ? row.isEndOfMonth : false;
    if(row.editMode){
      row.editMode = !row.editMode
    }else{
      row.editMode = true;
    }
  }

  saveRate(row){
    const sentRateType = (
      row.editRateType == row.rateType
      || (row.editRateType == "Multiplier" && row.rateType == "Flat Fee")
      || (row.editRateType == "Flat Fee" && row.rateType == "Multiplier")
    ) ? row.rateTypeId : null
    row.savingChanges = true;
    const rate: RateBuilderModel = {
      Id: row.rateId,
      Description: this.displayChargeType(row.editChargeTypeId),
      RateTypeId: sentRateType,
      Name: row.editName,
      ChargeTypeId: row.editChargeTypeId,
      ServiceCodeId: row.editServiceCodeId,
      IsRecurring: row.editIsRecurring == "Yes",
      IsCalculation: row.editRateType == "Calculation",
      RateTypeDescription: row.editMultiplierName,
      Amount: row.editRateType != "Calculation" ? row.editAmount : null,
      Multiplier: row.editRateType == "Calculation" ? row.editMultiplier : null,
      IsEndOfMonth: row.editIsEndOfMonth  ? row.editIsEndOfMonth : false,
    }


    this.serviceSubscriptionEditorService.postRate(rate)
      .toPromise()
      .then((rateResp: any) =>{
        ConsoleLogger.logInfo(`rate`, rate)
        ConsoleLogger.logInfo(`this.serviceSubscriptionService.postRate(rate)`, rateResp)
        row.savingChanges = false;
        this.loadData();
        this.toastrService.success("Rate saved.")
      },() =>{
        row.savingChanges = false;
        this.toastrService.error("Rate did not save.")
      })
  }



  public getCellClass({ row, column, value }): any {
    if(row.editMode){
      return ' d-flex align-items-center p-0 m-0';
    }
    return ' d-flex align-items-center';
  }

  public addRate(){
    const newRow = {
      id: 0,
      editChargeTypeId: -1,
      editServiceCodeId: -1,
      editRateType: "",
      editAmount: 0,
      editMultiplier: 0,
      editIsRecurring: "No",
      editMultiplierName: "",
      editName: "",
      editIsEndOfMonth: false,
      editMode: true,
    }
    this.rates = [newRow, ...this.rates];

  }

  public removeRow(row: any) {
    this.rates = this.rates.filter(r => r !== row);
  }
}



// WEBPACK FOOTER //
// ./src/app/developer/components/service-rates/service-rates.component.ts